export function enumValues(e: object): string[] {
  const values: any[] = Object.values(e);
  return values.splice(values.length / 2, values.length).map(item => item.toString());
}
